import { axiosApiService } from '../axios';
const AdminUserList = {
  AllUserListGet: async function () {
    const response = await axiosApiService.get(`/auth/users/`);
    return response.data;
  },
};
export default AdminUserList;
